/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum GanttCapacityFilter {
  All = 0,
  OnlyPositive = 1,
  OnlyNegative = 2,
}
